import {LOADER_HTML} from "../modulos/topbottom/utils";
import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import Streaming from "../streaming/streaming";

import('./css/brokerRecommendsPage.scss');

let currentPage = 1;

let formHandler, resultHandler, actionSelect, brokerSelect, recomSelect, dateIni, dateEnd;

/**
 * Recibe un Select y los valores que debe instalar como options
 * @param {HTMLSelectElement} Select que debe eliminar y reestablecer
 * @param {Object[]} values Array de objetos {id, name}
 */
const populateCombo = (combo, values) => {
    //Selección actual
    const currentSelected = combo.value;
    //Eliminar todos los select del combo
    Array.from(combo.options).forEach((option, index) => combo.remove(index));
    //Opción por defecto
    combo.options[0] = new Option(combo.dataset.emptylabel, "-1");
    //Cargar opciones del JSON a Select > Option
    values.forEach(item => combo.options[combo.options.length] = new Option(item.name, item.id));
    //Reestablecer la selección previa
    combo.value = currentSelected;
}

/**
 * Formatea un objeto Date en un string YYYY-MM-DD (si el separador es -)
 * @param {Date} date Objeto Date
 * @param {string} separator Elemento separador de grupo, por defecto -
 * @returns {string} Fecha formateada
 */
const dateToString = (date, separator = '-') => {
    const month = ('0'+String(date.getMonth() + 1)).slice(-2);
    const day = ('0'+String(date.getDate())).slice(-2);
    return `${date.getFullYear()}${separator}${month}${separator}${day}`;
}


/**
 * Realiza una consulta al server para obtener los posibles valores de los select
 */
const populateComponents = () => {
    const urlData = formHandler.dataset.urldata;
    const url = unmaskpath(`${urlData}##${actionSelect.value}##${brokerSelect.value}##${recomSelect.value}`);
    fetch(url)
        .then(result => result.json())
        .then(result => {
            if (result && result.hasOwnProperty('acciones'))  populateCombo(actionSelect, result.acciones);
            if (result && result.hasOwnProperty('brokers'))  populateCombo(brokerSelect, result.brokers);
            if (result && result.hasOwnProperty('recomendaciones'))  populateCombo(recomSelect, result.recomendaciones);
        })
        .catch(err => {
            resultHandler.innerHTML = '<div class="error-broker">No se pudo obtener la lista de recomendaciones de los brokers.</div>'
        });
}

/**
 * Parsea el DOM actual para establecer el funcionamiento del paginador de recomendaciones
 */
const parseHTMLReturned = () => {
    document.querySelectorAll('div.pagination a').forEach(a => {
        a.addEventListener('click', (e) => {
            e.preventDefault();
            if (a.classList.contains('current')) {
                //Si el item va a la página actual, inhabilitar
                return;
            }
            else if (a.classList.contains('page-next')) {
                //Si el item del paginador es página siguiente, ir a currentPage más 1
                return searchAndShow(currentPage+1);
            }
            else if (a.classList.contains('page-prev')) {
                //Si el item del paginador es página previa, ir a currentPage menos uno
                return searchAndShow(currentPage-1);
            }
            else {
                //Si el item del paginador es una página numérica, ir a dicha página
                return searchAndShow(a.innerText);
            }
        })
    });
}

/**
 * Realiza una consulta al server para obtener las recomendaciones a partir de los valores de los selectores
 * @param {number} page Número de página a mostrar. Por defecto, 1
 */
const searchAndShow = (page= 1) => {
    if (typeof page !== "number") page = parseInt(page);

    let iniDateString = '-1', endDateString = '-1';
    if (dateIni.selectedDates.length) iniDateString = dateToString(dateIni.selectedDates[0]);
    if (dateEnd.selectedDates.length) endDateString = dateToString(dateEnd.selectedDates[0]);

    const urlTable = formHandler.dataset.urltable;
    let url = `${urlTable}##${actionSelect.value}##${brokerSelect.value}##${recomSelect.value}`;
    url += `##${iniDateString}##${endDateString}##${page}`;
    url = unmaskpath(url);

    resultHandler.innerHTML = LOADER_HTML;

    fetch(url)
        .then(result => {
            if (result.status === 204) {
                resultHandler.innerHTML = '<div class="article-body block-txt"><p class="headline4">No hay recomendaciones acordes a su selección</p></div><hr>';
                return null;
            } else if (result.status === 200) {
                currentPage = page;
                result.text().then(html => {
                    resultHandler.innerHTML = html;
                    parseHTMLReturned();
                });
            }
        })
        .catch(err => {
            resultHandler.innerHTML = '<div class="broker-error">No fue posible obtener las recomendaciones de los brokers. Inténtelo pasados unos instantes</div>'
        })
}

const brokerRecommendsLogic = async () => {
    import('flatpickr/dist/flatpickr.css');
    const flatpickr = await import('flatpickr');
    const spanishFlatpickr = await import('flatpickr/dist/l10n/es');

    formHandler = document.querySelector('form#form_brokers_recommend');
    resultHandler =document.querySelector('#brokerRecommendsResults');

    actionSelect = document.querySelector('select[name="sRecommAction"]');
    brokerSelect = document.querySelector('select[name="sRecommBroker"]');
    recomSelect = document.querySelector('select[name="sRecommRecom"]');

    const dateIniInput = document.querySelector('input[name="iniDate"]');
    const dateEndInput = document.querySelector('input[name="endDate"]');
    dateIni = flatpickr.default(dateIniInput, {locale: spanishFlatpickr});
    dateEnd = flatpickr.default(dateEndInput, {locale: spanishFlatpickr});

    const onChangeEvent = (e) => {
        e.preventDefault();
        // populateComponents(); <-- Se vuelve loco
        searchAndShow();
    }
    actionSelect.addEventListener('change', onChangeEvent);
    brokerSelect.addEventListener('change', onChangeEvent);
    recomSelect.addEventListener('change', onChangeEvent);

    dateIni.set('onChange', (d) => {
        searchAndShow();
    })
    dateEnd.set('onChange', (d) => {
        searchAndShow();
    });
    formHandler.addEventListener('submit', (e) => {
        e.preventDefault();
        searchAndShow();
    });

    populateComponents();
    searchAndShow();
}
/**
 * Comportamiento de la página de los Broker Recomiendan
 * @returns {Promise<void>}
 */
export const brokerRecommendsPage = async () => {
    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    //Inicializa la lógica de la página
    brokerRecommendsLogic();
}
